import * as React from "react";
const SvgCopy = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M53,57h-24v-34h24z M35,18v-11h-24v34h13" }));
export default SvgCopy;
